import { useCallback } from 'react';
import { useOrg } from '@/organization/useOrg';
import { apiFetch } from '@/util/apiClient';

interface ApiResponse<T> {
  data: T;
  status: number;
  message?: string;
}

export function useOrgApiClient() {
  const { selectedOrg } = useOrg();

  const orgFetch = useCallback(
    async <T = unknown>(
      endpoint: string,
      init?: RequestInit,
    ): Promise<ApiResponse<T>> => {
      if (!selectedOrg) {
        throw new Error('No organization selected');
      }

      // Replace any :orgId placeholder with the actual ID
      const orgEndpoint = endpoint.replace(':orgId', selectedOrg.id);

      const response = await apiFetch<T>(orgEndpoint, init);
      return {
        data: response,
        status: 200,
        message: 'Success',
      };
    },
    [selectedOrg],
  );

  return { orgFetch, selectedOrg };
}
